import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const KanbanColumn = ({ title, projects, onEdit, statusColor }) => (
  <div className="flex-1 min-w-[300px] flex flex-col h-full bg-gray-50 dark:bg-gray-900 rounded-xl p-4 border border-gray-100 dark:border-gray-800">
    <div className={`flex items-center justify-between mb-4 pb-2 border-b-2 ${statusColor}`}>
      <h3 className="font-semibold text-gray-700 dark:text-gray-200">{title}</h3>
      <span className="bg-white dark:bg-gray-800 px-2 py-1 rounded-md text-xs font-bold shadow-sm dark:text-white">
        {projects.length}
      </span>
    </div>
    <div className="flex-1 overflow-y-auto space-y-3 pr-2 custom-scrollbar">
      {projects.map(project => (
        <div key={project.id} onClick={() => onEdit(project)} className="bg-white dark:bg-gray-800 p-4 rounded-xl shadow-sm border border-gray-100 dark:border-gray-700 hover:shadow-md transition cursor-pointer group">
          <div className="flex justify-between items-start mb-2">
            <span className={`text-[10px] uppercase font-bold px-2 py-1 rounded ${project.urgency === 'Critical' ? 'bg-red-50 text-red-600' : 'bg-gray-100 text-gray-500 dark:bg-gray-700 dark:text-gray-300'}`}>
              {project.urgency}
            </span>
            <SafeIcon icon={FiIcons.FiMoreHorizontal} className="text-gray-300 group-hover:text-gray-500" />
          </div>
          <h4 className="font-semibold text-gray-800 dark:text-white mb-1 line-clamp-2">{project.title}</h4>
          <p className="text-xs text-gray-500 dark:text-gray-400 mb-3">{project.stakeholder}</p>
          <div className="flex items-center justify-between text-xs text-gray-400">
            <div className="flex items-center gap-1">
              <SafeIcon icon={FiIcons.FiLayers} /> {project.version}
            </div>
            {project.delivery_date && (
              <div className="flex items-center gap-1 text-orange-500 font-medium">
                <SafeIcon icon={FiIcons.FiClock} /> {new Date(project.delivery_date).toLocaleDateString(undefined, { month: 'short', day: 'numeric' })}
              </div>
            )}
          </div>
        </div>
      ))}
    </div>
  </div>
);

const KanbanView = ({ projects, onEdit }) => {
  const columns = [
    { id: 'Waiting', label: 'Waiting', color: 'border-blue-500' },
    { id: 'Editing', label: 'Editing', color: 'border-yellow-500' },
    { id: 'Sent for review', label: 'Sent for Review', color: 'border-purple-500' },
    { id: 'Complete', label: 'Complete', color: 'border-green-500' }
  ];

  return (
    <div className="flex h-full gap-6 overflow-x-auto pb-4">
      {columns.map(col => (
        <KanbanColumn
          key={col.id}
          title={col.label}
          statusColor={col.color}
          projects={projects.filter(p => p.status === col.id || (col.id === 'Waiting' && !['Editing', 'Sent for review', 'Complete'].includes(p.status)))}
          onEdit={onEdit}
        />
      ))}
    </div>
  );
};

export default KanbanView;